// extracted by mini-css-extract-plugin
export default {"primary-font":"Summary_primary-font__UUa4h","secondary-font":"Summary_secondary-font__DDRry","virtual-code":"Summary_virtual-code__B-JdH","contacts":"Summary_contacts__EhmmB"};